// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatePicker-module__DialogPopup__K14XC {
    z-index: var(--ds-calendar-z-index);
    display: flex;
    background: none;
    border: none;
}

.DatePicker-module__DialogStatic__ld8gW {
    display: contents;
    background: none;
    border: none;
}
/* Layout-neutral wrapper used only to detect outside clicks in static mode. */
.DatePicker-module__StaticTrigger__yy5SK {
    display: contents;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DialogPopup": `DatePicker-module__DialogPopup__K14XC`,
	"DialogStatic": `DatePicker-module__DialogStatic__ld8gW`,
	"StaticTrigger": `DatePicker-module__StaticTrigger__yy5SK`
};
export default ___CSS_LOADER_EXPORT___;
